"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DISCORD_USERNAME_REGEXP = void 0;
exports.DISCORD_USERNAME_REGEXP = /^@?\w{2,32}#\d{2,10}$/;
//# sourceMappingURL=discord-username-regexp.js.map